// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big[data-v-5054085a]{font-family:\"Brown\",serif;font-size:1.5rem}@media only screen and (min-width: 960px){.big[data-v-5054085a]{font-size:2rem}}.small[data-v-5054085a]{font-family:\"Brown\",serif;font-size:1.5rem}@media only screen and (min-width: 960px){.text-small[data-v-5054085a]{font-size:.9rem}}", ""]);
// Exports
module.exports = exports;
